import { translations } from "./translations";

/**
 * Retrieves the translation for a given key and locale.
 * @param {string} key - The translation key (e.g., 'FULLSCREEN').
 * @param {string} locale - The locale code (e.g., 'EN' or 'ES').
 * @returns {string} - The translated string, or a fallback if not found.
 */
export function translate(key, locale = "EN") {
  const entry = translations[key];

  // If the key doesn't exist in the dictionary, return the key or handle as needed
  if (!entry) {
    return key;
  }

  // If the requested locale doesn't exist for that key, fall back to 'EN' or the key
  return entry[locale] || entry.EN || key;
}
